import { useCallback } from "react";

import { SortConfigItem, useReportContext } from "../../../report-context";

import { ReportColumn } from "@/types/evaluate";

export const useColumnSorting = () => {
  const { sortConfig, sortColumn } = useReportContext();

  const handleSort = useCallback(
    (column: ReportColumn, direction: "asc" | "desc") => {
      const isSorted = sortConfig.find((item: SortConfigItem) => item.columnId === column.id);
      if (isSorted && isSorted.direction === direction) {
        sortColumn(column.id, null);
      } else {
        sortColumn(column.id, direction);
      }
    },
    [sortConfig, sortColumn],
  );

  return { handleSort };
};
